<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>액션 시민 그룹 추가</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>
        <div class="sign_form custom_scroll">
            <ul>
                <li class="imp">
                    <label for="group_title" class="form_li_tit">제목</label>
                    <input id="group_title" type="text" placeholder="제목을 입력하세요" v-model="form_state.title" />
                </li>

                <li class="imp">
                    <label for="action_date" class="form_li_tit">활동 기간</label>
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input type="date" @keydown.enter="changeDate" name="" id="" v-model="form_state.startDate" @blur="changeDate" />
                        </div>
                        <div class="select_date">
                            <input type="date" @keydown.enter="changeDate" name="" id="" v-model="form_state.endDate" @blur="changeDate" />
                        </div>
                    </div>
                </li>
                <li>
                    <label for="cnt_round" class="form_li_tit">회차 수</label>
                    <div style="display: flex; align-items: center">
                        <input id="title" type="text" v-model="form_state.cntRound" />
                    </div>
                </li>
            </ul>

            <hr />
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _gray" @click="closeModal">취소</button>
                <button class="submit_btn _130 _main_blue" @click="add">저장</button>
            </div>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="modal.tab"
        :title="modal.title"
        :content="modal.content"
        @close="state.isShowModal = false"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import { onMounted, reactive, watch, ModalDefault, apiService, getMessageByCode, types, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            idx: { type: Number, default: 0 },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                isShowModal: false as boolean,
                mode: true as boolean, // true: add, false: modify
            });

            const modal = reactive({
                title: "" as string,
                content: "" as string,
                tab: 0 as number,
            });

            const form_state = reactive({
                title: "" as string,
                startDate: "" as string,
                endDate: "" as string,
                cntRound: 0 as number,
            });

            onMounted(() => {});

            watch(props, () => {});

            const closeModal = () => emit("close");

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            const add = async () => {
                if (!checkValue()) return;
                const param = {
                    cntRound: form_state.cntRound,
                    title: form_state.title,
                    startDate: form_state.startDate,
                    endDate: form_state.endDate,
                } as types.ReqActionGroup;
                const res = await apiService.actionGroup.add(param);
                if (res.returnCode === 0) {
                    state.isShowModal = true;
                    modal.tab = 7;
                    modal.title = "알림";
                    modal.content = "등록이 완료되었습니다.";
                } else {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                }
            };

            const checkValue = () => {
                if (!form_state.title) {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "제목을 입력해주세요";
                    return false;
                } else if (!form_state.startDate || !form_state.endDate) {
                    state.isShowModal = true;
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "활동기간을 입력해주세요";
                    return false;
                }
                return true;
            };

            const changeDate = async () => {
                if (form_state.startDate && form_state.endDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
            };

            return { state, modal, form_state, closeModal, callBackModal, add, props, changeDate, CommonUtils };
        },
    };
</script>

<style>
    .blocked,
    input:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
</style>
